import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConfigService} from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class ParametroService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
	}

	getAll(queryString: String = "") {
		this.host_api = this.ss.getData('host_api');
		this.dbname = this.ss.getData('dbname');

		let url = this.host_api + '/parametros' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getById(id) {
		this.host_api = this.ss.getData('host_api');
		this.dbname = this.ss.getData('dbname');

		let url = this.host_api + '/parametros/' + id;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ sessionStorage.getItem('api-token'));
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	save(parametro) {
		this.host_api = this.ss.getData('host_api');
		this.dbname = this.ss.getData('dbname');

		let url = this.host_api + '/parametros';
		let params = parametro;//JSON.stringify(categoria);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
		
	}

	update(parametro) {
		this.host_api = this.ss.getData('host_api');
		this.dbname = this.ss.getData('dbname');

		let url = this.host_api + '/parametros/' + parametro.id;
		let params = JSON.stringify(parametro);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	delete(id) {
		this.host_api = this.ss.getData('host_api');
		this.dbname = this.ss.getData('dbname');
		
		var url = this.host_api + '/parametros/' + id + '/del';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/parametro.service.ts